import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { AmlLimitsService } from '@core/services/aml-limits.service';
import { GeneralsService } from '@core/services/generals.service';
import { ValidationsService } from '@core/services/validations.service';
import { Constants } from '@shared/class/constants.class';
import { AmlLimit } from '@shared/interfaces/aml-limit';
import { Segment } from '@shared/interfaces/segment';

@Component({
  selector: 'app-aml-limits-edit',
  templateUrl: './aml-limits-edit.component.html'
})
export class AmlLimitsEditComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public amlLimit: AmlLimit;
  public amlLimitsList: Array<AmlLimit> = [];
  public segmentsList: Array<Segment> = [];
  public amlLimitForm: FormGroup;
  public countMax = 9999;

  constructor(
    public appConfig: AppConfig,
    private generalsService: GeneralsService,
    public amlLimitsService: AmlLimitsService,
    public dialogRef: MatDialogRef<AmlLimitsEditComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {}

  ngOnInit() {
    if (
      this.data.action === this.appConfig.ACTIONS.edit.id ||
      this.data.action === this.appConfig.ACTIONS.add.id
    ) {
      let segment: Segment;
      if (this.data.relationships.length) {
        this.data.relationships.forEach((element: any) => {
          segment = { id: element.id, name: element.attributes.name };
          this.segmentsList.push(segment);
        });
      }

      this.constants.title = this.appConfig.LANG.amlLimits.title;
      this.constants.action = this.data.action;

      this.amlLimitForm = new FormGroup(
        {
          idSegment: new FormControl('', Validators.required),
          monthlyValue: new FormControl('', [
            Validators.required,
            Validators.maxLength(9),
            ValidationsService.isInvalidNumberValidator
          ]),
          annualValue: new FormControl('', [
            Validators.required,
            Validators.maxLength(9),
            ValidationsService.isInvalidNumberValidator
          ]),
          monthlyCount: new FormControl('', [
            Validators.required,
            Validators.maxLength(4),
            ValidationsService.isInvalidNumberValidator
          ]),
          annualCount: new FormControl('', [
            Validators.required,
            Validators.maxLength(4),
            ValidationsService.isInvalidNumberValidator
          ])
        },
        [
          ValidationsService.validateRangeAmlLimitValue,
          ValidationsService.validateRangeAmlLimitCount
        ]
      );

      if (this.constants.action === this.appConfig.ACTIONS.edit.id) {
        this.constants.title =
          this.appConfig.LANG.title.edit + ' ' + this.constants.title;
        this.amlLimit = this.data.item;

        this.amlLimitForm.addControl(
          'id',
          new FormControl(this.amlLimit.id, [Validators.required])
        );

        this.amlLimitForm.patchValue({
          id: this.amlLimit.id,
          idSegment: this.amlLimit.idSegment,
          monthlyValue: this.amlLimit.monthlyValue,
          annualValue: this.amlLimit.annualValue,
          monthlyCount: this.amlLimit.monthlyCount,
          annualCount: this.amlLimit.annualCount
        });
      } else {
        if (this.segmentsList.length <= 0) {
          this.constants.admitted = false;
        } else {
          this.constants.title =
            this.appConfig.LANG.title.add + ' ' + this.constants.title;
        }
      }
    }
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.amlLimitForm;
    if (form.dirty && form.valid) {
      this.generalsService.save(
        this.constants.action,
        form,
        this.dialogRef,
        this.amlLimitsService
      );
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(300);
  }
}
